export const formatCurrency = (
  amount: number,
  currencyCode: string,
  maxFractionDigits = 0
): string => {
  // When callers request fractional precision (e.g. cents), also require the same minimum
  // digits so values like $100 and $100.50 do not mix inconsistent trailing zeros in one UI.
  const minFractionDigits = maxFractionDigits > 0 ? maxFractionDigits : 0;

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: minFractionDigits,
    maximumFractionDigits: maxFractionDigits,
  });

  return formatter.format(Number.isFinite(amount) ? amount : 0);
};
